var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-item" },
    [
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("common.category"),
            type: _vm.checkEmpty(_vm.errors.category) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.category)
              ? ""
              : _vm.errors.category[0],
          },
        },
        [
          _c("category-select", {
            model: {
              value: _vm.category,
              callback: function ($$v) {
                _vm.category = $$v
              },
              expression: "category",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("form.title"),
            type: _vm.checkEmpty(_vm.errors.title) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.title)
              ? ""
              : _vm.errors.title[0],
          },
        },
        [
          _c("b-input", {
            on: {
              blur: function ($event) {
                return _vm.validate("title")
              },
            },
            model: {
              value: _vm.title,
              callback: function ($$v) {
                _vm.title = $$v
              },
              expression: "title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("form.body"),
            message: _vm.checkEmpty(_vm.errors.editorModeOption)
              ? ""
              : _vm.errors.editorModeOption[0],
          },
        },
        [
          _c(
            "b-select",
            {
              model: {
                value: _vm.editorMode,
                callback: function ($$v) {
                  _vm.editorMode = $$v
                },
                expression: "editorMode",
              },
            },
            _vm._l(_vm.editorModes, function (editorMode) {
              return _c("option", {
                attrs: {
                  disabled:
                    editorMode.mode === "richText" &&
                    _vm.isEnabledRichText === false,
                },
                domProps: {
                  value: editorMode.mode,
                  textContent: _vm._s(_vm.$t(`term['${editorMode.mode}']`)),
                },
              })
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            type: _vm.checkEmpty(_vm.errors.body) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.body) ? "" : _vm.errors.body[0],
          },
        },
        [
          _vm.isEnabledRichText && _vm.editorMode === "richText"
            ? _c("rich-text-editor", {
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              })
            : _vm.editorMode === "markdown"
            ? _c("markdown-editor", {
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              })
            : _vm.editorMode === "mathjax"
            ? _c("b-input", {
                attrs: { type: "textarea" },
                on: {
                  blur: function ($event) {
                    return _vm.validate("body")
                  },
                },
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              })
            : _c("b-input", {
                ref: "inputBody",
                attrs: { type: "textarea" },
                on: {
                  blur: function ($event) {
                    return _vm.validate("body")
                  },
                },
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.editorMode === "mathjax"
        ? _c("div", [_c("vue-mathjax", { attrs: { formula: _vm.body } })], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("common.images"),
            type: _vm.checkEmpty(_vm.errors.images) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.images)
              ? ""
              : _vm.$t("msg.ErrorsExist"),
          },
        },
        [
          _vm.uploaderOptions
            ? _c("file-uploader", {
                attrs: {
                  "file-type": "image",
                  "image-action-button-type":
                    _vm.editorMode === "markdown" ? "copy" : "insert",
                  "is-draggable": true,
                  "enable-caption": true,
                  "enable-insert-button": true,
                  "uploader-options": _vm.uploaderOptions.image,
                },
                on: { "insert-image": _vm.insertImage },
                model: {
                  value: _vm.images,
                  callback: function ($$v) {
                    _vm.images = $$v
                  },
                  expression: "images",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            label: _vm.$t("form.answerType"),
            message: _vm.checkEmpty(_vm.errors.answerType)
              ? ""
              : _vm.errors.answerType[0],
          },
        },
        [
          _c(
            "b-select",
            {
              model: {
                value: _vm.answerType,
                callback: function ($$v) {
                  _vm.answerType = $$v
                },
                expression: "answerType",
              },
            },
            _vm._l(_vm.answerTypes, function (answerType) {
              return _c("option", {
                domProps: {
                  value: answerType,
                  textContent: _vm._s(_vm.$t(`form.answerTypes.${answerType}`)),
                },
              })
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.answerType === "text"
        ? _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("term.answer"),
                message: _vm.checkEmpty(_vm.errors.correctAnswerText)
                  ? ""
                  : _vm.errors.correctAnswerText[0],
                type: _vm.checkEmpty(_vm.errors.correctAnswerText)
                  ? ""
                  : "is-danger",
              },
            },
            [
              _c("b-input", {
                attrs: { type: "textarea" },
                on: {
                  blur: function ($event) {
                    return _vm.validate("correctAnswerText")
                  },
                },
                model: {
                  value: _vm.correctAnswerText,
                  callback: function ($$v) {
                    _vm.correctAnswerText = $$v
                  },
                  expression: "correctAnswerText",
                },
              }),
            ],
            1
          )
        : _vm.answerType === "select"
        ? _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("term.answer"),
                type: _vm.checkEmpty(_vm.errors.answers) ? "" : "is-danger",
                message: _vm.checkEmpty(_vm.errors.answers)
                  ? ""
                  : _vm.errors.answers[0],
              },
            },
            [
              _c("table", { staticClass: "table is-fullwidth" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "narrow-width" }),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("term.content")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("term.correct")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.answers, function (answer, index) {
                    return _c("tr", { key: index }, [
                      _c("th", {
                        domProps: {
                          textContent: _vm._s(_vm.answerLabels[index]),
                        },
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.answers[index],
                              expression: "answers[index]",
                            },
                          ],
                          staticClass: "textarea",
                          attrs: { placeholder: "Input Answer", rows: "2" },
                          domProps: { value: _vm.answers[index] },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.answers, index, $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-radio", {
                            attrs: { "native-value": index },
                            model: {
                              value: _vm.correctAnswer,
                              callback: function ($$v) {
                                _vm.correctAnswer = $$v
                              },
                              expression: "correctAnswer",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-5",
          attrs: {
            label: _vm.$t("term.requiredTimeToAnswer"),
            type: _vm.checkEmpty(_vm.errors.requiredTime) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.requiredTime)
              ? ""
              : _vm.errors.requiredTime[0],
          },
        },
        [
          _c("b-input", {
            attrs: {
              placeholder: _vm.$t("form.unitSeconds"),
              type: "number",
              expanded: false,
            },
            on: {
              blur: function ($event) {
                return _vm.validate("requiredTime")
              },
            },
            model: {
              value: _vm.requiredTime,
              callback: function ($$v) {
                _vm.requiredTime = $$v
              },
              expression: "requiredTime",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            label: _vm.$t("form.answerExplanation"),
            message: _vm.checkEmpty(_vm.errors.answerExplanation)
              ? ""
              : _vm.errors.answerExplanation[0],
            type: _vm.checkEmpty(_vm.errors.answerExplanation)
              ? ""
              : "is-danger",
          },
        },
        [
          _c("b-input", {
            ref: "inputAnswerExplanation",
            attrs: { type: "textarea" },
            on: {
              blur: function ($event) {
                return _vm.validate("answerExplanation")
              },
            },
            model: {
              value: _vm.answerExplanation,
              callback: function ($$v) {
                _vm.answerExplanation = $$v
              },
              expression: "answerExplanation",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-5",
          attrs: {
            label: _vm.$t("common.images"),
            type: _vm.checkEmpty(_vm.errors.answerExpImages) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.answerExpImages)
              ? ""
              : _vm.$t("msg.ErrorsExist"),
          },
        },
        [
          _vm.uploaderOptions
            ? _c("file-uploader", {
                attrs: {
                  "file-type": "image",
                  "image-action-button-type":
                    _vm.editorMode === "markdown" ? "copy" : "insert",
                  "is-draggable": true,
                  "enable-caption": true,
                  "uploader-options": _vm.uploaderOptions.image,
                },
                on: { "insert-image": _vm.insertImage },
                model: {
                  value: _vm.answerExpImages,
                  callback: function ($$v) {
                    _vm.answerExpImages = $$v
                  },
                  expression: "answerExpImages",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("form.files"),
            type: _vm.checkEmpty(_vm.errors.files) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.files)
              ? ""
              : _vm.$t("msg.ErrorsExist"),
          },
        },
        [
          _vm.uploaderOptions
            ? _c("file-uploader", {
                attrs: {
                  "file-type": "file",
                  "uploader-options": _vm.uploaderOptions.file,
                },
                on: { "copy-url": _vm.copyUrl },
                model: {
                  value: _vm.files,
                  callback: function ($$v) {
                    _vm.files = $$v
                  },
                  expression: "files",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-6",
          attrs: {
            label: _vm.$t("common.link"),
            type: _vm.checkEmpty(_vm.errors.links) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.links)
              ? ""
              : _vm.$t("msg.ErrorsExist"),
          },
        },
        [
          _vm.links.length > 0
            ? _c(
                "ul",
                _vm._l(_vm.links, function (link) {
                  return _c(
                    "li",
                    { key: link.id },
                    [
                      _c("link-inputs", {
                        attrs: { link: link },
                        on: {
                          "updated-link": _vm.updateLink,
                          delete: _vm.deleteLink,
                          "has-error": _vm.setLinksError,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("b-field", [
        _c(
          "button",
          {
            staticClass: "button",
            attrs: { disabled: _vm.isAddLinkBtnEnabled === false },
            on: { click: _vm.addLink },
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("i", { staticClass: "fas fa-link" }),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("common.addFor", { target: _vm.$t("common.link") })
                )
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.globalError
        ? _c("div", { staticClass: "block has-text-danger mt-6" }, [
            _vm._v("\n    " + _vm._s(_vm.globalError) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field mt-6" }, [
        _vm.isEdit
          ? _c("div", { staticClass: "control" }, [
              _c("button", {
                staticClass: "button is-warning",
                attrs: { disabled: _vm.isLoading || _vm.hasErrors },
                domProps: { textContent: _vm._s(_vm.$t("common.edit")) },
                on: {
                  click: function ($event) {
                    return _vm.save(false)
                  },
                },
              }),
            ])
          : _c("div", { staticClass: "control" }, [
              _c("button", {
                staticClass: "button is-info",
                attrs: { disabled: _vm.isLoading || _vm.hasErrors },
                domProps: { textContent: _vm._s(_vm.$t("common.doCreate")) },
                on: {
                  click: function ($event) {
                    return _vm.save(false)
                  },
                },
              }),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control" }, [
          _c("button", {
            staticClass: "button is-light",
            attrs: { disabled: _vm.isLoading },
            domProps: { textContent: _vm._s(_vm.$t("common.cancel")) },
            on: { click: _vm.cancel },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }